import React from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import whoWeAreImg from '../../assets/img/about/who_we_are.png';
import ourStoryImg from '../../assets/img/about/our_story.png';
import ourValuesImg from '../../assets/img/about/our_values.png';

const About = () => {
  return (
    <Box sx={{ backgroundColor: "#f9f9f9", py: 4 }}>
      <Container>
        <Typography
          variant="body1"
          className="pb-3"
          sx={{
            fontSize: "1.25rem",
            lineHeight: "1.6",
            fontWeight: 500,
            color: '#10374A',
            textAlign: 'center',
            maxWidth: '1000px',
            mx: 'auto',
            mb: 4
          }}
        >
          Royale Spaces is your trusted top real estate agency in Amaravati, dedicated to helping buyers, sellers, and investors explore the best property opportunities in Andhra Pradesh’s capital region. With a legacy built in the UK real estate market, Royale Spaces now brings its global standards of transparency, professionalism, and trust to Amaravati real estate.
        </Typography>

        {/* Who We Are Section */}
        <Card sx={{ mb: 6, boxShadow: 3, borderRadius: 4, overflow: 'hidden' }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image={whoWeAreImg}
                alt="Leading Real Estate Agency in Amaravati"
                sx={{ width: '100%', height: { xs: 300, md: 500 }, objectFit: 'cover' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Typography variant="h4" sx={{ color: '#10374A', fontWeight: 800, mb: 2 }}>
                  Who We Are
                </Typography>
                <Typography variant="h6" sx={{ color: '#d8b035', fontWeight: 600, mb: 3 }}>
                  Royale Spaces — A UK-Based Real Estate Company Now Expanding in Amaravati, Andhra Pradesh.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#444', lineHeight: 1.7 }}>
                  Royale Spaces offers premium open plots in Amaravati with clear titles and verified documentation. We specialize in residential and commercial plots for sale in Amaravati, ensuring transparency and trust. As a top-rated real estate agency in Amaravati, we help investors find secure and profitable property opportunities.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#444', lineHeight: 1.7 }}>
                  We specialize in open plots, residential plots, and commercial land for sale in Amaravati, connecting clients with verified properties, clear documentation, and genuine pricing. Our mission is to make your Amaravati property investment secure, simple, and profitable — whether you’re looking to build your dream home or expand your investment portfolio.
                </Typography>
                <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.7, fontWeight: 500 }}>
                  As one of the top-rated real estate companies in Amaravati, Royale Spaces focuses on creating high-value investment plots in and around the Amaravati Capital Region. Backed by deep local market insights and ethical business practices, we ensure every property deal adds real value to your future.
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Card>

        {/* Our Story Section */}
        <Card sx={{ mb: 6, boxShadow: 3, borderRadius: 4, overflow: 'hidden' }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Typography
                  variant="h4"
                  sx={{ color: "#10374A", fontWeight: 800, mb: 3 }}
                >
                  Our Story
                </Typography>
                <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                  Established with a vision to revolutionize the real estate experience, Royale Spaces brings international expertise to the Indian market. Our journey began in the UK, where we built a reputation for excellence, reliability, and client satisfaction. Today, we are proud to bring that same dedication to Amaravati and Hyderabad. We understand that buying property is one of the most significant decisions in a person's life, and our story is defined by the thousands of families we've helped secure their future. Our team combines global standards with deep local knowledge, ensuring that every plot we offer in the Amaravati Capital Region meets the highest standards of quality and legality.
                </Typography>
              </CardContent>
            </Grid>
            <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
              <CardMedia
                component="img"
                image={ourStoryImg}
                alt="Our Story - Royale Spaces"
                sx={{ width: '100%', height: { xs: 300, md: 450 }, objectFit: 'cover' }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Our Values Section */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, overflow: 'hidden' }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image={ourValuesImg}
                alt="Our Values - Royale Spaces"
                sx={{ width: '100%', height: { xs: 300, md: 450 }, objectFit: 'cover' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Typography
                  variant="h4"
                  sx={{ color: "#10374A", fontWeight: 800, mb: 3 }}
                >
                  Our Values
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 600,
                    color: '#d8b035',
                    mb: 3
                  }}
                >
                  At Royale Spaces, we are driven by a set of core values that define who we are and how we serve our clients:
                </Typography>
                <Box component="ul" sx={{ pl: 2, color: '#444' }}>
                  {[
                    "Integrity – Upholding honesty and ethical conduct in every interaction.",
                    "Innovation – Fostering creativity and forward-thinking solutions.",
                    "Collaboration – Embracing teamwork to achieve excellence together.",
                    "Customer-Centricity – Placing clients' needs and satisfaction at the heart of our services.",
                    "Excellence – Delivering high-quality results with a commitment to continuous improvement.",
                    "Accountability – Taking ownership of our actions and outcomes.",
                  ].map((value, index) => (
                    <li key={index} style={{ marginBottom: '12px' }}>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {value}
                      </Typography>
                    </li>
                  ))}
                </Box>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Box>
  );
};

export default About;
